/* 各同意文言 */
import React, { useState } from 'react';
import Popup from './Popup';
import Heading from './Heading';
import Annotation from '../atoms/Annotation';
import CenterButton from '../atoms/CenterButton';
import { agreement_label } from '../Const';

interface Props {
  agreement_content: {
    id: number;
    title: string;
    sub_title: string;
    text: string;
    type: number;
  };
  label_number: number;
  check_agree: (id: number, agreement: boolean) => void;
}

const AgreementBox: React.FC<Props> = ({ agreement_content, label_number, check_agree }) => {
  const [modal_show, setModalShow] = useState(false);
  const [popup_button, setPopupButton] = useState({
    label: '同意する',
    variant: 'success',
    handleClick: () => handleClick(true),
  });

  // ポップアップの開閉、ポップアップ内の同意ボタン押下時同意したと判定する
  const handleClick = (agreement: boolean = false) => {
    setModalShow(modal_show => !modal_show);
    if (agreement) {
      check_agree(agreement_content.id, agreement);
    }
  };

  return (
    <>
      <div className="content-box">
        <Heading label={agreement_label[label_number]} size="s" />
        <Annotation text="「同意書を表示する」を押して、同意書を表示し、内容をご確認下さい。" />
        <CenterButton
          btn_class="btn-base"
          label="同意書を表示する"
          handleClick={() => handleClick()}
        />
      </div>
      <Popup
        title={agreement_content.title}
        sub_title={agreement_content.sub_title}
        text={agreement_content.text}
        toggleShow={modal_show}
        toggleClose={() => handleClick()}
        first_button={popup_button}
      />
    </>
  );
};

export default AgreementBox;
